import { byId } from "./dom";

let timer: number | undefined;

/** Muestra un mensaje flotante (regiones aria-live del toast). */
export function toast(message: string): void {
  const el = byId("toast");
  el.textContent = message;
  el.classList.add("show");
  window.clearTimeout(timer);
  timer = window.setTimeout(() => el.classList.remove("show"), 3200);
}
